module.exports = __webpack_public_path__ + "img/ico-upload.4fc88098.svg";